import { Button, Tooltip } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { useNavigateToSmartChargeDppSettings } from '../../hooks'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useIsTariffRedirectDisabled } from 'src/Libs/system-settings/hooks/use-is-tariff-redirect-disabled'

const useStyles = makeStyles()(theme => ({
  button: {
    display: 'flex',
    color: theme.palette.text.header,
    borderColor: theme.palette.text.header,
    '&:hover': {
      borderColor: theme.palette.grey.grey01,
      color: theme.palette.grey.grey01,
    },
  },
}))

/**
 * This component is a button that redirects to the EMS activation page.
 */
const RedirectToEmsActivationButton: React.FC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const text = t('common.activate-now')
  const { navigateToSmartChargeBatteryDppSettings } = useNavigateToSmartChargeDppSettings()
  const isTariffRedirectDisabled = useIsTariffRedirectDisabled()

  const handleOnClick = (): void => {
    navigateToSmartChargeBatteryDppSettings()
  }

  return (
    <Tooltip title={isTariffRedirectDisabled ? t('common.disabled-because-of-offline-system') : undefined}>
      <span>
        <Button onClick={handleOnClick} className={classes.button} disabled={isTariffRedirectDisabled}>
          {text}
        </Button>
      </span>
    </Tooltip>
  )
}

export default RedirectToEmsActivationButton
